module.exports = __webpack_public_path__ + "img/41.8ce14f54.jpg";